import IPublishService from './IPublishService';
import IInitData from '../DataObject/Game/IInitData';
import IEntryData from '../DataObject/Game/IEntryData';
import IPlayResult from '../DataObject/Play/IPlayResult';

export enum GamePathName {
    Init = 'game.init', // 對應原本的slot.init
    Entry = 'game.entry', // 對應原本的game.data
    Play = 'game.play',
}

export type GamePublishDataType = {
    [GamePathName.Init]: IInitData;
    [GamePathName.Entry]: IEntryData;
    [GamePathName.Play]: IPlayResult;
};

export default interface IGameService extends IPublishService<GamePublishDataType> {
    getEntryData(isCache: boolean): Promise<IEntryData>;
    getInitData(): Promise<IInitData>;
}
